module.exports = __webpack_public_path__ + "img/free-blue.fd97fad7.png";